import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import { Button } from 'reactstrap'

const BusinessContact = (props) => {

    const [forms, setForms] = useState({
        name: '',
        email: '',
        company: '',
        phone: '',
        message: ''
    });
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));
    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value })
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const submitHandler = e => {
        e.preventDefault();
        if (validator.allValid()) {
            validator.hideMessages();
            setForms({
                name: '',
                email: '',
                company: '',
                phone: '',
                message: ''
            })
        } else {
            validator.showMessages();
        }
    };

    return (

        <section className="calltoaction_section_new">
            <div className="container">
                <div className="row">
                    <div className="col-lg-5">
                        <h2>Get Your Free AI SEO <br/> Audit</h2>
                        <p className="heading_description mb-0 text-dark" style={{marginTop:'40px'}}>We’ll analyze your entity signals, AEO/ <br/> GEO visibility, technical SEO, <br/> and programmatic page opportunities then <br/> deliver a 4-step plan to grow trials and <br/> demos.</p>

                        <Button className='read_more' style={{marginLeft:'0px',marginTop:'20px'}}>Get Free AI SEO Audit</Button>

                    </div>
                    <div className="col-lg-7">
                        <div className="instant_contact_form">
                            {/* <div className="small_title text-white">
                                <i className="fa-solid fa-envelope-open-text text-white"></i>
                                Let's Connect!
                            </div> */}
                            <h3 className="form_title text-center">
                                Send Us Your Details For Customized <br/> Solutions
                            </h3>
                            <p className="heading_description text-center text-dark">* All Fields are compulsory</p>
                            <form className="xb-item--form contact-from" onSubmit={(e) => submitHandler(e)}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <input
                                                value={forms.name}
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                onBlur={(e) => changeHandler(e)}
                                                onChange={(e) => changeHandler(e)}
                                                placeholder="Full Name" />
                                            {validator.message('name', forms.name, 'required|alpha_space')}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <input
                                                value={forms.company}
                                                type="text"
                                                name="company"
                                                className="form-control"
                                                onBlur={(e) => changeHandler(e)}
                                                onChange={(e) => changeHandler(e)}
                                                placeholder="Company" />
                                            {validator.message('company', forms.company, 'required')}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <input
                                                value={forms.company}
                                                type="company"
                                                name="company"
                                                className="form-control"
                                                onBlur={(e) => changeHandler(e)}
                                                onChange={(e) => changeHandler(e)}
                                                placeholder="Your Company Name" />
                                            {validator.message('company', forms.company, 'required')}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <input
                                                value={forms.phone}
                                                type="phone"
                                                name="phone"
                                                className="form-control"
                                                onBlur={(e) => changeHandler(e)}
                                                onChange={(e) => changeHandler(e)}
                                                placeholder="Your Phone No." />
                                            {validator.message('phone', forms.phone, 'required|phone')}
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <input
                                                value={forms.designation}
                                                type="designation"
                                                name="designation"
                                                className="form-control"
                                                onBlur={(e) => changeHandler(e)}
                                                onChange={(e) => changeHandler(e)}
                                                placeholder="Designation" />
                                            {validator.message('designation', forms.designation, 'required')}
                                        </div>
                                    </div>

                                     <div className="col-md-6">
                                        <div className="form-group">
                                            <input
                                                value={forms.country}
                                                type="country"
                                                name="country"
                                                className="form-control"
                                                onBlur={(e) => changeHandler(e)}
                                                onChange={(e) => changeHandler(e)}
                                                placeholder="Country" />
                                            {validator.message('country', forms.country, 'required')}
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="form-group">
                                            <textarea
                                                onBlur={(e) => changeHandler(e)}
                                                onChange={(e) => changeHandler(e)}
                                                value={forms.message}
                                                type="text"
                                                name="message"
                                                className="form-control"
                                                placeholder="Brief Your Requirements*">
                                            </textarea>
                                            {validator.message('message', forms.message, 'required')}
                                        </div>
                                
                                    </div>

                                    <div className="col-12 text-center">
                                        <button type="submit" className="contct_btn btn btn-primary">
                                            <span className="btn_label" data-text="Send Request">Submit</span>
                                        </button>

                                        <p style={{marginTop:'15px'}} className="heading_description text-center text-dark">By submitting this form, you agree to our <b>Privacy Policy.</b></p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default BusinessContact;